import React from 'react';
import {useSearchParams} from 'react-router-dom';
import Authentication from 'views/scenes/auth/Authentication';

const MagicLink = (props) => {
  const [params] = useSearchParams();

  return (
    <Authentication token={params.get('token')} />
  );
};

export default React.memo(MagicLink);
